export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  const result = await Notification.requestPermission();
  return result === 'granted';
};

export const showCallNotification = ({ title, body, icon = '/favicon.ico' }) => {
  if (!('Notification' in window)) return null;
  if (Notification.permission !== 'granted') return null;
  const n = new Notification(title, {
    body,
    icon,
    tag: 'incoming-call',
    requireInteraction: true,
    silent: true,
  });
  n.onclick = () => {
    window.focus();
    n.close();
  };
  return n;
};
